// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as Recoil$OrcaPaymentPage from "../libraries/Recoil.bs.js";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";
import * as DropdownField$OrcaPaymentPage from "./DropdownField.bs.js";

var phoneNumberFormatError = "Enter your phone number without the country code or a leading 0 (e.g. 712345678).";

function getMobileMoneyPhoneValidity(value, countryCode) {
  var codeDigits = countryCode.replace(/\D/g, "");
  if (value === "") {
    return [
            undefined,
            ""
          ];
  } else if (value.startsWith("0") || codeDigits !== "" && value.startsWith(codeDigits)) {
    return [
            false,
            phoneNumberFormatError
          ];
  } else {
    return [
            true,
            ""
          ];
  }
}

function PhoneNumberPaymentInput(props) {
  var phoneRef = React.useRef(null);
  var nameRef = React.useRef(null);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var match$1 = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match$1.localeString;
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var showDetails = PaymentType$OrcaPaymentPage.getShowDetails(match.fields.billingDetails, loggerState);
  var match$2 = Recoil$OrcaPaymentPage.useLoggedRecoilState(RecoilAtoms$OrcaPaymentPage.userPhoneNumber, "phone", loggerState);
  var setPhone = match$2[1];
  var phone = match$2[0];
  var match$3 = Recoil$OrcaPaymentPage.useLoggedRecoilState(RecoilAtoms$OrcaPaymentPage.userFullName, "fullName", loggerState);
  var setFullName = match$3[1];
  var fullName = match$3[0];
  var match$4 = React.useState(function () {
        return "";
      });
  var setDisplayValue = match$4[1];
  var supportedCountryCodes = [
    "KE",
    "TZ",
    "UG",
    "RW",
    "BI",
    "SS",
    "ET",
    "SO",
    "DJ",
    "ER",
    "KM",
    "MG",
    "MW",
    "MU",
    "MZ",
    "SC",
    "ZM",
    "ZW",
    "US",
    "GB",
    "FR",
    "AU",
    "BR",
    "CN",
    "IN",
    "JP",
    "MX",
    "NG",
    "RU",
    "ZA"
  ];
  var countryAndCodeCodeList = Utils$OrcaPaymentPage.getArray(Core__Option.getOr(Core__JSON.Decode.object(Utils$OrcaPaymentPage.phoneNumberJson), {}), "countries").filter(function (countryObj) {
        var code = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(countryObj), "country_code", "");
        return supportedCountryCodes.includes(code);
      });
  var phoneNumberCodeOptions = Core__Array.reduce(countryAndCodeCodeList, [], (function (acc, countryObj) {
          var countryObjDict = Utils$OrcaPaymentPage.getDictFromJson(countryObj);
          var countryFlag = Utils$OrcaPaymentPage.getString(countryObjDict, "country_flag", "");
          var phoneNumberCode = Utils$OrcaPaymentPage.getString(countryObjDict, "phone_number_code", "");
          var countryName = Utils$OrcaPaymentPage.getString(countryObjDict, "country_name", "");
          var phoneNumberOptionsValue_value = countryFlag + "#" + phoneNumberCode;
          var phoneNumberOptionsValue_label = countryFlag + " " + countryName + " " + phoneNumberCode;
          var phoneNumberOptionsValue_displayValue = countryFlag + " " + phoneNumberCode;
          var phoneNumberOptionsValue = {
            value: phoneNumberOptionsValue_value,
            label: phoneNumberOptionsValue_label,
            displayValue: phoneNumberOptionsValue_displayValue
          };
          acc.push(phoneNumberOptionsValue);
          return acc;
        }));
  var countryObj = Utils$OrcaPaymentPage.getDictFromJson(Core__Option.getOr(countryAndCodeCodeList.filter(function (countryObj) {
                  return Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(countryObj), "country_code", "") === "KE";
                })[0], {
            phone_number_code: "",
            country_flag: ""
          }));
  var flag = Utils$OrcaPaymentPage.getString(countryObj, "country_flag", "");
  var code = Utils$OrcaPaymentPage.getString(countryObj, "phone_number_code", "");
  var defaultCountryCodeFilteredValue = flag + "#" + code;
  var match$5 = React.useState(function () {
        return defaultCountryCodeFilteredValue;
      });
  var valueDropDown = match$5[0];
  var getCountryCodeSplitValue = function (val) {
    return Core__Option.getOr(val.split("#")[1], "");
  };
  var changePhone = function (ev) {
    var val = ev.target.value.replace(/\D|\s/g, "");
    setPhone(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.countryCode = getCountryCodeSplitValue(valueDropDown);
          newrecord.value = val;
          return newrecord;
        });
  };
  var changeName = function (ev) {
    var val = ev.target.value;
    var isValid = val !== "" && /^\D*$/.test(val);
    var errorString = val === "" || isValid ? "" : localeString.invalidCardHolderNameError;
    setFullName(function (param) {
          return {
                  value: val,
                  isValid: isValid,
                  errorString: errorString
                };
        });
  };
  var onBlurName = function (ev) {
    var val = ev.target.value;
    var isValid = val !== "" && /^\D*$/.test(val);
    setFullName(function (prev) {
          var newrecord = Caml_obj.obj_dup(prev);
          newrecord.errorString = val === "" ? prev.errorString : (
              isValid ? "" : localeString.invalidCardHolderNameError
            );
          newrecord.isValid = isValid;
          return newrecord;
        });
  };
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit && fullName.value === "") {
            return setFullName(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.errorString = localeString.nameEmptyText(localeString.fullNameLabel);
                        return newrecord;
                      });
          }
          
        }), [fullName]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  React.useEffect((function () {
          setPhone(function (prev) {
                var newrecord = Caml_obj.obj_dup(prev);
                newrecord.countryCode = getCountryCodeSplitValue(valueDropDown);
                return newrecord;
              });
        }), [valueDropDown]);
  React.useEffect((function () {
          var match = getMobileMoneyPhoneValidity(phone.value, getCountryCodeSplitValue(valueDropDown));
          Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                [
                  "phoneNumberFormatInvalid",
                  Caml_obj.equal(match[0], false)
                ],
                [
                  "phoneNumberFormatMessage",
                  match[1]
                ]
              ]);
        }), [
        phone.value,
        valueDropDown
      ]);
  React.useEffect((function () {
          return (function () {
                    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                          [
                            "phoneNumberFormatInvalid",
                            false
                          ],
                          [
                            "phoneNumberFormatMessage",
                            ""
                          ]
                        ]);
                  });
        }), []);
  React.useEffect((function () {
          var findDisplayValue = Core__Option.getOr(phoneNumberCodeOptions.find(function (ele) {
                    return ele.value === valueDropDown;
                  }), DropdownField$OrcaPaymentPage.defaultValue);
          setDisplayValue(function (param) {
                return Core__Option.getOr(findDisplayValue.displayValue, Core__Option.getOr(findDisplayValue.label, findDisplayValue.value));
              });
        }), [phoneNumberCodeOptions]);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: showDetails.phone === "Auto",
              children: null
            }, React.createElement(PaymentField$OrcaPaymentPage.make, {
                  setValue: setFullName,
                  value: fullName,
                  onChange: changeName,
                  onBlur: onBlurName,
                  fieldName: localeString.fullNameLabel,
                  name: "fullName",
                  type_: "text",
                  paymentType: "Payment",
                  placeholder: localeString.fullNamePlaceholder,
                  inputRef: nameRef
                }), React.createElement(PaymentField$OrcaPaymentPage.make, {
                  value: phone,
                  valueDropDown: valueDropDown,
                  setValueDropDown: match$5[1],
                  dropDownOptions: phoneNumberCodeOptions,
                  onChange: changePhone,
                  fieldName: "Phone Number",
                  name: "phone",
                  type_: "tel",
                  paymentType: "Payment",
                  maxLength: 14,
                  placeholder: "000 000 000",
                  inputRef: phoneRef,
                  displayValue: match$4[0],
                  setDisplayValue: setDisplayValue
                }));
}

var make = PhoneNumberPaymentInput;

export {
  phoneNumberFormatError ,
  getMobileMoneyPhoneValidity ,
  make ,
}
/* react Not a pure module */
